import React from "react";
import { Box, alpha, useTheme } from "@mui/material";

/**
 * Área superior unificada (cabeçalho + abas) com separação suave do conteúdo.
 */
const TeamSpacePaneChrome = ({ children, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flexShrink: 0,
        bgcolor: "background.paper",
        position: "relative",
        zIndex: 2,
        boxShadow: `0 1px 0 ${alpha(theme.palette.divider, 0.06)}`,
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: 6,
          pointerEvents: "none",
          background: `linear-gradient(to bottom, ${alpha(theme.palette.background.paper, 0.5)}, transparent)`,
          transform: "translateY(100%)",
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default TeamSpacePaneChrome;
